import {
	createStore
} from 'vuex'
import utils from '../js/utils.js'
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
	modules[moduleName] = modulesFiles(modulePath).default
	return modules
}, {})

export default createStore({
	state: {
		globalUrl: 'https://app.xiangmaitech.cn',
		requestType: 'java', //后台语言 php、java
		// token:localStorage.getItem('token') ? localStorage.getItem('token'):'',
		token: utils.getLocal('token'),
		adminId: utils.getLocal('adminId'),
		info: utils.getLocal('info', 'json'),
		routeCurrent: utils.getLocal('routeCurrent'),
		totalUnreadCount: 0, // 未读消息数量
	},
	getters: {},
	mutations: {
		setToken(state, value) { // 设置存储token
			state.token = value;
			localStorage.setItem('token', value);
		},
		setAdminId(state, value) { // 设置存储adminId
			state.adminId = value;
			localStorage.setItem('adminId', value);
		},
		setInfo(state, value) { // 设置存储账户详情
			state.info = value;
			localStorage.setItem('info', JSON.stringify(value));
		},
		setRouteCurrent(state, value) { // 设置存储路由路径
			state.routeCurrent = value;
			localStorage.setItem('routeCurrent', value);
		},
		setTotalUnreadCount(state, value) { // 设置存储未读消息数量
			state.totalUnreadCount = value;
		}

	},
	actions: {},
	modules
})